// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    addToEndOfChain,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import {
    AddAccount,
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { addAccount as addAccountApi } from "@west/App/Services/AccountService";
import { xGoogleAnalyticsState } from "@west/App/Store/Reducers";
import { getUseExternalLogin } from "@west/App/Store/Selectors/SettingsSelectors";
import { getDataLayer } from "@west/XDL/Utilities/tracking";

const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const useExternalLogin = getUseExternalLogin(props.getState());

    if (useExternalLogin) {
        delete props.apiParameter.account.userName;
        delete props.apiParameter.account.password;
        delete props.apiParameter.account.properties?.phoneNumber;
    }
};

// XNG-Changes: service
export const xAddAccount: typeof AddAccount = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await addAccountApi(props.apiParameter);
    watchForOtherTabSessionChange();
};

export const _GaTrackAccountCreation: typeof AddAccount = props => {
    if (props.apiResult.successful) {
        const state = props.getState() as xGoogleAnalyticsState;
        if (state.xGoogleAnalytics.registrationEvent) {
            const dataLayer = getDataLayer();
            if (!dataLayer) {
                return;
            }
            const googleAnalyticsData = {
                event: state.xGoogleAnalytics.registrationEventName,
                email: props.apiParameter.account.email,
                company: props.apiParameter.account.properties?.companyName,
                authentication_state: state.xGoogleAnalytics.authenticationState,
            };

            dataLayer.push(googleAnalyticsData);
        }
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, AddAccount, xAddAccount);
addToEndOfChain(chain, _GaTrackAccountCreation);
